import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Non più in uso",
  "Spare part list": "Elenco dei ricambi",
  "Download Excel": "Scarica Excel",
  "Recent search list": "Elenco delle ricerche recenti",
  "No data": "Nessun dato",
  "spare part": "pezzo di ricambio",
  "none": "nessuno",
  "no value": "nessun valore",
  "No results found": "Nessun risultato trovato",
  "Spare parts for": "Ricambi per",
  "Could not load cumulated data": "Impossibile caricare i dati cumulativi",
  "commissioning part": "parte di messa in servizio",
  "wear part": "parte di usura",
  "Search": "Ricerca",
  "Tk": "Tk",
  "Spare part number": "Numero di parte di ricambio",
  "drawing": "disegno",
  "Products for": "Prodotti per",
  "Available": "Disponibile",
  "MM": "MM",
  "The entered order code is invalid": "Il codice d\u0027ordine inserito non è valido",
  "Recommended": "Consigliato",
  "No data available for the entered search parameters": "Non sono disponibili dati per i parametri di ricerca inseriti",
  "Search spare parts": "Ricerca parti di ricambio",
  "Order code / product root / serial number": "Codice d\u0027ordine / radice del prodotto / numero di serie",
  "Characteristic": "Caratteristica",
  "Please enter an order code": "Inserire un codice d\u0027ordine",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Per quanto riguarda gli aspetti di qualità e sicurezza, Endress+Hauser raccomanda vivamente l\u0027uso esclusivo di ricambi originali Endress+Hauser. \nLa manutenzione e la riparazione dello strumento devono essere effettuate esclusivamente da personale qualificato. \nÈ necessario rispettare la documentazione del dispositivo, le norme e i requisiti di legge applicabili, nonché gli eventuali certificati!",
  "Maintenance advice": "Consigli per la manutenzione",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Per quale/i prodotto/i può essere utilizzato il mio pezzo di ricambio? Compilando il codice d\u0027ordine del ricambio (ad esempio, 71002865 o XPD0024) si possono visualizzare i dispositivi in cui il ricambio può essere utilizzato.",
  "tool": "strumento",
  "Production numbers": "Numeri di produzione",
  "New alternative": "Nuova alternativa",
  "There are no items selected. Please use the checkboxes to make your selection": "Non ci sono articoli selezionati. Utilizzate le caselle di controllo per effettuare la vostra selezione",
  "Service segmentation": "Segmentazione dei servizi",
  "Seg": "Seg",
  "Valid": "Valido",
  "Pos": "Pos",
  "Value": "Valore",
  "service segmentation 2": "Parti che richiedono conoscenze di base. La partecipazione con successo alla formazione di base E+H è un prerequisito.",
  "Phase out date": "Data di uscita graduale",
  "service segmentation 1": "Parti che richiedono conoscenze di base.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Quali sono i ricambi disponibili per il mio prodotto? Inserendo il codice d\u0027ordine (ad es. FTC260-AA2A1 o PMC51-BA21JB1CGBTDJB) o l\u0027id del prodotto (ad es. FTC260 o 83F50) si ottengono i ricambi desiderati.",
  "Set filter": "Impostare il filtro",
  "Search date": "Data di ricerca",
  "Group": "Gruppo",
  "Warning": "Avvertenze",
  "Description": "Descrizione",
  "Cancel": "Annullamento",
  "service segmentation 4": "Parti per la riparazione in fabbrica. Le conoscenze specialistiche sono obbligatorie.",
  "service segmentation 3": "Parti che richiedono conoscenze specialistiche. La partecipazione con successo alla formazione avanzata E+H è un prerequisito.",
  "Drawing Position Number": "Numero di posizione del disegno",
  "Spare parts search": "Ricerca ricambi",
  "Confirm": "Confermare",
  "Ordercode too short": "Codice d\u0027ordine troppo corto",
  "Product status": "Stato del prodotto",
  "Open": "Aperto",
  "Clear": "Libero",
  "PDF file with assembly instructions": "File PDF con istruzioni di montaggio",
  "Search products": "Ricerca prodotti",
  "Export": "Esportazione",
  "Production date": "Data di produzione",
  "Order stop": "Arresto dell\u0027ordine",
  "Calibration until": "Calibrazione fino a",
  "PDF file with compatibility information": "File PDF con informazioni sulla compatibilità",
  "Add selection to cart": "Aggiungi la selezione al carrello",
  "Mounting advices": "Consigli per il montaggio",
  "Recommended parts only": "Solo parti consigliate",
  "not applicable": "non applicabile",
  "accessories": "accessori",
  "Cumulative spare parts list": "Elenco cumulativo delle parti di ricambio",
  "YYYY": "YYYY",
  "Title": "Titolo",
  "Error": "Errore",
  "Ordercode too long": "Codice d\u0027ordine troppo lungo",
  "Functions": "Funzioni",
  "Rec": "Rec",
  "Type": "Tipo",
  "Spare sensor until": "Sensore di ricambio fino a quando",
  "Spare parts until": "Pezzi di ricambio fino a",
  "Filter": "Filtro",
  "Check all": "Controllare tutti",
  "Order code": "Codice d\u0027ordine",
  "Repair until": "Riparazione fino a quando",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Codice categoria",
  "Phase out": "Eliminazione graduale",
  'Compatibility advices': 'Documenti aggiuntivi',
  'Co.': 'Doc. agg.',
} as LocalizedDictionary;
